import script from "./ExternalServiceConfigurationTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalServiceConfigurationTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__